import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  Spinner,
  TabContent,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
} from "reactstrap";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

//Images

import profileBg from "../../../assets/images/profile-bg.png";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";

import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import { calculateAge } from "../../../Components/Hooks/calculateAge";
import { MaskText } from "../../../Components/Hooks/MaskText";
import { ProfileDetailThunk } from "../../../slices/auth/login/thunk";
import { useDispatch } from "react-redux";
import CommonLoading from "../../../Components/Common/CommonLoading";
import { WindowScrollController } from "@fullcalendar/core/internal";

const SimplePage = () => {
  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [missingFields, setMissingFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [completionPercentage, setCompletionPercentage] = useState(0);

  useEffect(() => {
    setLoading(true);
    dispatch(ProfileDetailThunk(userData?.token))
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [userData?.token]);

  // useEffect(() => {
  //   if (userData) {
  //     const requiredFields = {
  //       name: userData?.name,
  //       email: userData?.personal_details?.email,
  //       phone: userData?.personal_details?.phone,
  //       dob: userData?.personal_details?.dob,
  //       gender: userData?.personal_details?.gender,
  //       pan: userData?.personal_details?.pan,
  //       nationality_code: userData?.personal_details?.nationality_code,
  //       branch_code: userData?.personal_details?.branch_code,
  //       address: userData?.personal_details?.address?.line_one,
  //     };

  //     //   const totalFields = Object.keys(requiredFields).length;
  //     const totalFields = 10;
  //     const filledFields = Object.values(requiredFields).filter(Boolean).length;
  //     const missing = Object.keys(requiredFields).filter(
  //       (key) => !requiredFields[key]
  //     );

  //     setMissingFields(missing);
  //     setCompletionPercentage(Math.round((filledFields / totalFields) * 100));
  //   }
  // }, [userData]); // Runs only when userData changes

  // SwiperCore.use([Autoplay]);

  const [activeTab, setActiveTab] = useState("1");
  const [activityTab, setActivityTab] = useState("1");
  const [isPanVisible, setIsPanVisible] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

  // logic to show active exchange data as per true/false condition
  const activeExchanges = Object.entries(
    userData?.trade?.active_exchanges || {}
  )
    .filter(([_, value]) => value) // keep only true
    .map(([key]) => key);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <div className="profile-foreground position-relative mx-n4 mt-n4">
                <div className="profile-wid-bg">
                  <img src={profileBg} alt="" className="profile-wid-img" />
                </div>
              </div>
              <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                <Row className="g-4">
                  <div className="col-auto pe-0">
                    <div className="avatar-lg centerContent">
                      {userData?.profile_image ? (
                        <img
                          src={userData?.profile_image}
                          alt="user-img"
                          className="img-thumbnail rounded-circle"
                          loading="lazy"
                          style={{
                            padding: "0",
                            width: "5rem",
                            height: "5rem",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.style.display = "none"; // hide broken image
                            e.target.parentNode.innerHTML = `
      <i class='mdi mdi-account-circle text-muted' style='font-size: 5rem;'></i>
    `;
                          }}
                        />
                      ) : (
                        <i
                          className="mdi mdi-account-circle text-muted   "
                          style={{
                            fontSize: "5rem",
                          }}
                        ></i>
                      )}
                    </div>
                  </div>

                  <Col>
                    <div className="p-2">
                      <h3 className="text-white mb-1">{userData?.name}</h3>
                      <p className="text-white fs-p-sm mb-0">
                        Trading Code: {userData?.trade?.short_code}
                      </p>
                      <p className="text-white fs-p-sm ">
                        CDSL Details:{" "}
                        {userData?.trade?.dp_id === "N/A" ||
                        userData?.trade?.dp_account_number === "N/A"
                          ? "N/A"
                          : `${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
                      </p>
                      <div className="hstack text-white gap-2 d-flex align-items-center">
                        <div className=" fs-p-sm">
                          <i className="mdi mdi-phone me-1 text-white fs-16 align-middle"></i>
                          {`+91 ${userData?.personal_details?.mobile}`}
                        </div>
                        <div>|</div>
                        <div className="fs-p-sm">
                          <i className="mdi mdi-email-outline me-1 text-white fs-16 align-middle"></i>
                          {userData?.personal_details?.email}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <Row>
                <Col lg={12}>
                  <div>
                    <div className="d-flex flex-wrap gap-3">
                      <Nav
                        pills
                        className=" animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            href="#overview-tab"
                            className={classnames(" ", {
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggleTab("1");
                            }}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                            }}
                          >
                            <i className="ri-airplay-fill d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              Account Details
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            href="#"
                            className={classnames(" ", {
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              navigate("/profile-settings", {
                                state: { tab: "5" },
                              });
                              //   toggleTab("2");
                            }}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                            }}
                          >
                            <i className="mdi mdi-bank d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              Bank Details
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            href="#"
                            className={classnames(" ", {
                              active: activeTab === "3",
                            })}
                            onClick={() => {
                              navigate("/profile-settings", {
                                state: { tab: "6" },
                              });
                            }}
                            style={{
                              backgroundColor: "rgba(255, 255, 255, 0.2)",
                            }}
                          >
                            <i className="mdi mdi-security d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              Security & Password
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <div className="d-flex gap-1 gap-sm-3 mt-0 mt-sm-md-2 flex-wrap">
                        <div className="flex-shrink-0">
                          <Link to="/edit_option" className="btn btn-success">
                            <i className="ri-edit-box-line align-bottom"></i>{" "}
                            Edit Account Details
                          </Link>
                        </div>
                        <div className="flex-shrink-0">
                          <Link
                            to="/profile-settings"
                            className="btn btn-success"
                          >
                            <i className="ri-file-search-line align-bottom"></i>{" "}
                            View Account Details
                          </Link>
                        </div>
                      </div>
                    </div>

                    <TabContent activeTab={activeTab} className="pt-4">
                      <TabPane tabId="1">
                        <Row>
                          <Col xxl={3} xl={3}>
                          {userData?.profile_progres == 100 ? (
                            <Card>
                              <CardBody>
                                <h5 className="card-title mb-5">
                                  Complete Your Profile
                                </h5>
                                {/* <Progress
                              value={completionPercentage}
                              color="#FE7171"
                              className="animated-progess custom-progress progress-label"
                            >
                              <div className="label">{completionPercentage}%</div>{" "}
                            </Progress> */}
                                <div className="progress animated-progress custom-progress progress-label">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                      width: `${userData?.profile_progress}%`,
                                      backgroundColor: "#0fa67b",
                                    }}
                                    aria-valuenow={userData?.profile_progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  >
                                    <div className="label">
                                      {userData?.profile_progress}%
                                    </div>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          ):null}

                            <Card>
                              <CardHeader>
                                <h5 className="card-title mb-0">Info</h5>
                              </CardHeader>
                              <CardBody>
                                <div className="w-100 d-flex flex-column">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <p className="mb-0 ps-0 fw-semibold fs-p-sm w-50 text-start">
                                      Client ID :
                                    </p>
                                    <p className="mb-0 ms-2 fs-p-sm w-50 text-start">
                                      {" "}
                                      {`${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <p className="mb-0 ps-0 fw-semibold fs-p-sm w-50 text-start">
                                      Branch Code :
                                    </p>
                                    <p className="mb-0 ms-2 fs-p-sm w-50 text-start">
                                      {" "}
                                      {userData?.personal_details?.branch_code}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 ps-0 fw-semibold fs-p-sm w-50 text-start">
                                      Account Opening Date:
                                    </p>
                                    <p className="mb-0 ms-2 fs-p-sm w-50 text-start">
                                      {" "}
                                      {userData?.trade?.account_opening_date}
                                    </p>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                            <Card>
                              <CardHeader>
                                <h5 className="card-title mb-0">Address</h5>
                              </CardHeader>
                              <CardBody>
                                <p className="fs-p-sm m-0 p-0">{`${userData?.personal_details?.address?.line_one}, ${userData?.personal_details?.address?.line_two}, ${userData?.personal_details?.address?.line_three}, ${userData?.personal_details?.address?.line_four}, ${userData?.personal_details?.state}, India - ${userData?.personal_details?.pincode}`}</p>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={9} xl={9}>
                            <Card>
                              <CardHeader>
                                <h5 className="card-title mb-0">
                                  Personal Details
                                </h5>
                              </CardHeader>
                              <CardBody>
                                <Row>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Full Name (Username)
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {userData?.name}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Mobile Number
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {`+91 ${userData?.personal_details?.mobile}`}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          E-mail ID
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {userData?.personal_details?.email}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Date of Birth (DOB)
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {userData?.personal_details?.dob}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Age
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {userData?.personal_details?.dob
                                            ? calculateAge(
                                                userData.personal_details.dob
                                              )
                                            : "N/A"}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Gender
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {userData?.personal_details?.gender}
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                  {userData?.personal_details?.father_full_name?.trim() ||
                                  userData?.personal_details?.mother_full_name?.trim() ? (
                                    <Col
                                      xxl={4}
                                      xl={4}
                                      lg={6}
                                      xs={6}
                                      md={4}
                                      sm={6}
                                      className="col-12"
                                    >
                                      <div className="d-flex mb-2">
                                        <div className="flex-grow-1 overflow-hidden">
                                          <p className="text-muted fs-caption-bg mb-1">
                                            {userData?.personal_details?.father_full_name?.trim()
                                              ? "Father's Name"
                                              : userData?.personal_details?.mother_full_name?.trim()
                                              ? "Mother's Name"
                                              : null}
                                            {/* father_full_name */}
                                          </p>
                                          <p className="fs-p-sm fw-medium mb-0">
                                            {userData?.personal_details?.father_full_name?.trim() ??
                                              userData?.personal_details?.mother_full_name?.trim() ??
                                              null}
                                          </p>
                                        </div>
                                      </div>
                                    </Col>
                                  ) : null}

                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          PAN
                                        </p>

                                        <span className="d-flex align-items-center m-0 p-0">
                                          <p className="me-2 fs-p-sm fw-medium mb-0">
                                            {/* {isPanVisible
                                              ? userData?.personal_details?.pan
                                              : MaskText(
                                                  userData?.personal_details
                                                    ?.pan,
                                                  "*"
                                                )} */}
                                            {userData?.personal_details?.pan}
                                          </p>

                                          {/* <i
                                            type="button"
                                            onClick={() =>
                                              setIsPanVisible(
                                                (prevState) => !prevState
                                              )
                                            }
                                            className={`mdi text-muted m-0 ${
                                              isPanVisible
                                                ? "mdi-eye-off"
                                                : "mdi-eye"
                                            }`}
                                          /> */}
                                        </span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    xxl={4}
                                    xl={4}
                                    lg={6}
                                    xs={6}
                                    md={4}
                                    sm={6}
                                    className="col-12"
                                  >
                                    <div className="d-flex mb-2">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Nationality
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          Indian
                                        </p>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>

                            <Row>
                              <Col
                                xxl={6}
                                xl={6}
                                lg={6}
                                sm={12}
                                className="col-12"
                              >
                                <Card>
                                  <CardHeader className="align-items-center d-flex">
                                    <h4 className="card-title mb-0  me-2">
                                      Active Segment Details
                                    </h4>
                                  </CardHeader>
                                  <CardBody>
                                    <div className="w-100 d-flex flex-column">
                                      {activeExchanges?.length > 0 ? (
                                        activeExchanges?.map((exchange, i) => (
                                          <div
                                            key={exchange}
                                            className={
                                              i === 0
                                                ? "pb-2 border-bottom d-flex align-items-center justify-content-between"
                                                : i ===
                                                  activeExchanges?.length - 1
                                                ? "pt-2 d-flex align-items-center justify-content-between"
                                                : "py-2 border-bottom d-flex align-items-center justify-content-between"
                                            }
                                          >
                                            <h4 className="text-primary m-0 p-0">
                                              {exchange}
                                            </h4>
                                            <span className="badge bg-success">
                                              Active
                                            </span>
                                          </div>
                                        ))
                                      ) : (
                                        <div className="text-muted text-center py-2">
                                          No active exchange available
                                        </div>
                                      )}
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col
                                xxl={6}
                                xl={6}
                                lg={6}
                                sm={12}
                                className="col-12"
                              >
                                <Card>
                                  <CardHeader className="align-items-center d-flex">
                                    <h4 className="card-title mb-0  me-2">
                                      Nominees
                                    </h4>
                                  </CardHeader>
                                  <CardBody>
                                    <div className="d-flex">
                                      <div className="flex-grow-1 overflow-hidden">
                                        <p className="text-muted fs-caption-bg mb-1">
                                          Nominee Name
                                        </p>
                                        <p className="fs-p-sm fw-medium mb-0">
                                          {
                                            userData?.personal_details
                                              ?.nominee_full_name || "-"
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SimplePage;
